import { render, staticRenderFns } from "./SessionsAdmin.vue?vue&type=template&id=31b2a0b0"
import script from "./SessionsAdmin.vue?vue&type=script&lang=js"
export * from "./SessionsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports